import { TreeNew, Icon } from "antd";
const TreeNode = TreeNew.TreeNode;
import WeaNewScroll from "../wea-new-scroll";
import cloneDeep from "lodash/cloneDeep";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import trim from "lodash/trim";
import toString from "lodash/toString";
import classNames from "classnames";

import WeaLocaleProvider from "../wea-locale-provider";
const { formatMultiLang } = WeaLocaleProvider;
let timeout = null;
export default class main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  generateTreeNodes() {
    let { data, filterData, renderItem } = this.props;
    const treeNodes = [];
    this.ids = [];
    this.nodeObj = {};
    if (!isEmpty(data)) {
      if (!isEmpty(filterData)) {
        data = data.filter(
          item => !filterData.some(i => toString(i.id) === toString(item.id))
        );
      }
      data.map(item => {
        item.id = toString(item.id);
        item.name = formatMultiLang(item.name);
        let title = (
          <div
            className="tree-title"
            dangerouslySetInnerHTML={{ __html: item.name }}
          />
        );
        if (renderItem) {
          title = renderItem(item);
        }
        treeNodes.push(
          <TreeNode
            title={title}
            name={item.name}
            key={item.id}
            isLeaf={true}
            id={item.id}
            type={item.type}
          />
        );
        this.ids.push(item.id);
        this.nodeObj[item.id] = item;
      });
    }
    return treeNodes;
  }
  checkHandler(v, p) {
    let _this = this;
    // 取消上次延时未执行的方法
    clearTimeout(timeout);
    //执行延时
    timeout = setTimeout(function() {
      _this.props.checkedCb && _this.props.checkedCb(v, p);
    }, 200);
  }
  onDoubleClick(e, node) {
    const key = node.props.eventKey;
    clearTimeout(timeout);
    const { data } = this.props;
    const target = data.filter(item => toString(item.id) === toString(key))[0];
    this.props.onDoubleClick && this.props.onDoubleClick(key, target, node);
  }
  onDragStart(obj) {
    clearTimeout(timeout);
    this.props.checkedCb && this.props.checkedCb([]);
  }
  onDrop(obj) {
    const dragNodes = obj.dragNodesKeys;
    const targetNode = obj.node.props.eventKey;
    const result = [];
    this.ids
      .filter(item => {
        return dragNodes.indexOf(item) === -1;
      })
      .forEach(id => {
        result.push(this.nodeObj[id]);
        if (id === targetNode) {
          dragNodes.forEach(drag => {
            result.push(this.nodeObj[drag]);
          });
        }
      });
    this.props.onDrag && this.props.onDrag(result);
  }
  render() {
    const {
      checkedKeys,
      height,
      draggable,
      className,
      data,
      header
    } = this.props;
    const treeNodes = this.generateTreeNodes();
    const traClass = classNames({
      borderRadius: header
    });
    return (
      <div className={`wea-transfer-list ${className} ${traClass}`}>
        <div className="wea-transfer-list-wrapper">
          {header && <div className="wea-transfer-list-header">{header}</div>}
          <WeaNewScroll height={height || 400}>
            {!isEmpty(data) && (
              <TreeNew
                className="transfer-tree"
                draggable={draggable}
                onDragStart={this.onDragStart.bind(this)}
                onDrop={this.onDrop.bind(this)}
                onSelect={this.checkHandler.bind(this)}
                onDoubleClick={this.onDoubleClick.bind(this)}
                selectedKeys={checkedKeys}
                multiple={true}
                async={true}
                selectable={true}
              >
                {treeNodes}
              </TreeNew>
            )}
          </WeaNewScroll>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-transfer/list.js